import yItemsLoop from '../classes/yItemsLoop.js'

export default [
    function () {
        return {
            templateUrl: '/partial/app.partials.rundown.directives.draft_navigation',
            replace: false,
            controller: [
                'Item',
                '$mdDialog',
                '$mdToast',
                '$scope',
                'selector',
                '$state',
                '$http',
                rmRundownDraftNavigation
            ],
            controllerAs: 'ctrl',
            scope: {
                yItems: '=',
                type: '@',
                typeId: '=',
                broadcastId: '=',
                readOnly: '=',
                itemModelTypes: '=',
                title: '@'
            }
        }
    }]

class rmRundownDraftNavigation extends yItemsLoop {
    constructor (Item, $mdDialog, $mdToast, $scope, selector, $state, $http) {
        super()

        this.Item = Item
        this.$mdDialog = $mdDialog
        this.$mdToast = $mdToast
        this.$scope = $scope
        this.selector = selector
        this.$state = $state
        this.$http = $http
        this.readOnly = $scope.readOnly

        this.isDragging = false
        this.isCreateItemAllowed = true

        let unRegister = $scope.$watch(() => {
            return $scope.yItems
        }, (newValue) => {
            if (newValue) {
                this.items = $scope.yItems
                this.extraItemData = this.selector.extraItemData

                unRegister()
            }
        })

        this.checkNextClick()
    }

    getModelType (modelTypeId) {
        return this.$scope.itemModelTypes
            .find(modelType => modelType.id == modelTypeId)
    }

    checkNextClick () {
        let checkSelectionUp = function (e) {
            if (e.keyCode === 27) { //unselected (27 = escape)
                this.$scope.$apply(() => {
                    this.selector.removeAll()
                })
            } else if ((e.keyCode == 68 || e.keyCode == 46) && this.shouldCheckNextClick) { //delete fucntion (68 = d, 46 = delete)
                if (this.selector.selectedItems.length > 0) {
                    this.removeItems(this.selector.selectedItems)
                }
            }
        }.bind(this)

        let checkClick = function (e) {
            if (this.shouldCheckNextClick) {
                this.shouldCheckNextClick = false

                this.selector.removeAll()

                this.$scope.$apply()
            }
        }.bind(this)

        $(document).on('keyup', checkSelectionUp)
        $(document).on('click', checkClick)

        this.$scope.$on('$destroy', () => {
            $(document).off('keyup', checkSelectionUp)
            $(document).off('click', checkClick)
        })
    }

    removeItems (items, $event) {
        this.$mdDialog.show(
            {
                controller: 'ConfirmManyDialogCtrl',
                templateUrl: 'confirmManyDialog.ngTemplate',
                parent: angular.element(document.querySelector('#popupContainer .md-dialog-container')),
                targetEvent: $event,
                clickOutsideToClose: true,
                multiple: true,
                locals: {
                    count: items.length,
                    option: null
                }
            }).then(() => {

            items.map(item => {
                this.Item.delete({ id: item.get('id') }, () => {
                    // let items = this.items.toArray();
                    // for (let i = 0; i < items.length; i++) {
                    //     if (items[i] == item) {
                    //         // this.items.delete(i, 1);
                    //     }
                    // }
                })
            })
        }, () => {
        })
    }

    deleteItem (yItem) {
        const id = yItem.get('id')
        const title = yItem.get('title').toString()
        this.$mdDialog.show({
            controller: 'ConfirmDialogCtrl',
            templateUrl: 'confirmDialog.ngTemplate',
            parent: angular.element(document.querySelector('#popupContainer .md-dialog-container')),
            multiple: true
        }).then(() => {
            this.Item.delete({ id: id }, () => {
                this.$mdToast.show({
                    templateUrl: '/partial/app.partials.toasts.delete?object=item&title=' + title,
                    hideDelay: 6000,
                    position: ('top right')
                })

            })
        })
    }

    validateRundown (yItems) {
        const { type, id } = this.getType()
        const items = yItems.toJSON().map(({ id, updated_at }) => ({ id, updated_at }))
        this.$http.post(`items/validate-rundown/${type}/${id}`, items)
            .then(res => { console.log(res.data, res) })
    }

    createItemAfter (afterItemId) {
        if (!this.isCreateItemAllowed) {
            console.warn('You are creating items to fast. Please slow down')
            return
        }

        this.isCreateItemAllowed = false
        setTimeout(() => {
            this.isCreateItemAllowed = true
        }, 500)

        const {
            $scope,
            $state,
            Item
        } = this

        Item.save({
            [this.getDraftIdName()]: $scope.typeId,
            tags: [],
            contacts: [],
            afterItemId: afterItemId,
            placeOnEndOfBlock: !afterItemId
        }, item => {
            $state.go('.edit', {
                type: $scope.type,
                itemId: item.id
            })
        })
    }

    getDraftIdName () {
        switch (this.$scope.type) {
            case('personal'):
                return 'user_draft_id'
            case('program'):
                return 'program_draft_id'
            case('station'):
                return 'station_draft_id'
        }
    }

    onDragStart (item, event) {

        if (this.selector.selectedItems.length == 0 || !this.selector.isAllowedToBeSelected(item)) {
            this.selector.removeAll()
            this.selector.add(item)
        }

        this.isDragging = true

        this.selector.setDraggingItem()

        event.dataTransfer.setDragImage(event.target.children[0], 0, 0)

    }

    getType () {
        return {
            type: this.$scope.type,
            id: this.$scope.typeId
        }
    }

    onDrop (index, yBlock, event) {
        dndCleanupFix('#rundownContainer')

        const droppedYItems = this.selector.getSelectedInOrder()
        this.$http.post('/items/dnd-items', {
            toType: this.getType(),
            itemIds: this.yItemsToIds(droppedYItems),
            placeOnIndex: index,
            copySelection: event.ctrlKey
        }).then(({ data }) => {
            if (data.updatedItems) {
                for (const yItem of droppedYItems) {
                    const updateAtString = data.updatedItems[yItem.get('id')]
                    if (updateAtString) yItem.set('updated_at', updateAtString)
                }
            }
        })

        this.selector.removeAll()

        return true
    }

    onDragEnd () {
        this.isDragging = false
        this.selector.removeDraggingItem()
    }

    onSelected (yItem, event) {
        let items = this.getItems(this.items)

        if (event.ctrlKey) {
            this.shouldCheckNextClick = true
            event.stopPropagation()
            event.preventDefault()

            this.selector.toggle(yItem)

        } else if (event.shiftKey) {
            this.shouldCheckNextClick = true
            event.stopPropagation()
            event.preventDefault()

            this.selector.add(yItem)
            if (this.selector.isAllowedToBeSelected(yItem)) {
                let a = this.selector.getIndex(this.selector.firstSelected)
                let b = this.selector.getIndex(yItem)
                let first, last

                if (a > b) {
                    first = b
                    last = a
                } else {
                    first = a
                    last = b
                }

                items.forEach((item, index) => {
                    let selected = (index >= first && index <= last)

                    let found = this.selector.indexOf(item)

                    if (selected && found == -1) {
                        this.selector.add(item)
                    } else if (!selected && found > -1) {
                        this.selector.remove(item)
                    }
                })
            } else {
                this.selector.add(yItem)
            }

        } else {
            if (!event.target.classList.contains('trash')) {
                this.$state.go('.edit', { type: this.$scope.type, itemId: yItem.get('id'), blockId: null })
            }
        }
    }
}
